import { RematchDispatch, RematchRootState } from '@rematch/core';
import React from 'react';
import { connect } from 'react-redux';
import { ErrorPageWrapper } from '../components/Shared';
import { RootModel } from '../state';
import { InternalError } from '../types';

interface ComponentWithErrorHandlerProps {
  error?: InternalError;
}

export const withErrorHandler = (Component: React.FC<any>) => {
  const ComponentWithErrorHandler = (
    props: ComponentWithErrorHandlerProps
  ): JSX.Element => {
    const getErrorMessage = (httpStatus?: number) => {
      switch (httpStatus) {
        case 403:
          return 'You do not have permission to access the ProjectWise project(s) that you are looking for.';
        case 404:
          return 'We cannot find the ProjectWise project that you are looking for or it does not exist.';
        default:
          return 'Application encountered an unexpected error. Please reload the page to try again.';
      }
    };

    return props.error ? (
      <ErrorPageWrapper
        errorType={props.error.httpStatus?.toString()}
        description={
          props.error.message ?? getErrorMessage(props.error.httpStatus)
        }
      />
    ) : (
      <Component />
    );
  };

  return connect(mapState, mapDispatch)(ComponentWithErrorHandler);
};

const mapState = (state: RematchRootState<RootModel>) => {
  return {
    error: state.global.error,
  };
};

const mapDispatch = (state: RematchDispatch<RootModel>) => {
  return {};
};
